import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.countertop.value;

export const value = setCalculationModeCountertopValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_COUNTERTOP_VALUE',
  { value: '', label: '' }
);
